module.exports = __webpack_public_path__ + "img/n4.e9698f69.png";